import {baseUrl, httpTimeout} from "@/constants/globalConfig";

/**
 * axiosJson 全局配置参数：json传参
 *  参数说明详见：http://www.axios-js.com/zh-cn/docs/
 *
 * @author Francis
 * @since 2024-03-07 16:39
 */
export default {
    baseUrl: baseUrl,
    headers: {
        "Content-Type": "application/json;charset=UTF-8"
    },
    timeout: httpTimeout,
    withCredentials: true,
    responseType: "json",
}
